import { AlertIcon } from '@approvalmax/ui';
import { FC, memo } from 'react';

import { useOffboardingContext } from '../../OffboardingContext';
import { WarningCellProps } from './WarningCell.types';

const WarningCell: FC<WarningCellProps> = memo((props) => {
    const { item } = props;

    const { showErrors, selectedReplacements } = useOffboardingContext();

    const isInvalid = item.required && showErrors && !selectedReplacements[item.id];

    return <>{isInvalid && <AlertIcon color='red100' />}</>;
});

export default WarningCell;
